import { ComponentType, SVGProps } from "react";
import styled from "styled-components";
import ToolsSvg from "../assets/illustrations/tools.svg?react";
import PsychologistAndPatientSvg from "../assets/illustrations/psyAndPatient.svg?react";
import TreatmentSvg from "../assets/illustrations/treatment.svg?react";

export type IllustrationSize = "sm" | "md" | "lg";

const sizeMap: Record<IllustrationSize, string> = {
  sm: "184px",
  md: "327px",
  lg: "450px",
};

type IllustrationProps = SVGProps<SVGSVGElement> & {
  size?: IllustrationSize;
};

const Wrapper = styled.div<{ $width: string }>`
  width: ${({ $width }) => $width};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const withSize = (SvgComponent: ComponentType<SVGProps<SVGSVGElement>>) => {
  const Sized = ({ size, ...rest }: IllustrationProps) => {
    if (!size) return <SvgComponent {...rest} />;
    return (
      <Wrapper $width={sizeMap[size]}>
        <SvgComponent {...rest} />
      </Wrapper>
    );
  };
  Sized.displayName = SvgComponent.displayName || SvgComponent.name;
  return Sized;
};

export const Illustration = {
  Tools: withSize(ToolsSvg),
  PsychologistAndPatient: withSize(PsychologistAndPatientSvg),
  Treatment: withSize(TreatmentSvg),
} as const;

export type Illustration = keyof typeof Illustration;
